var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivingF2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 28,
    width: 25,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9092 28.2289H56.4899V56.5309H32.9092V28.2289Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_1487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 58,
    height: 58
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.223633 0.760232V55.8205C-0.223633 56.275 0.144883 56.6432 0.5991 56.6432H55.6593C56.1138 56.6432 56.4821 56.275 56.4821 55.8205V0.760232C56.4821 0.306016 56.1138 -0.0625 55.6593 -0.0625H0.5991C0.144883 -0.0625 -0.223633 0.306016 -0.223633 0.760232Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_18_1487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7176 56.5249C44.5577 56.5249 44.3954 56.492 44.2471 56.4263C43.7858 56.2261 32.9531 51.3816 32.9531 41.4829V33.163C32.9531 32.6642 33.2708 32.2171 33.7413 32.0523L44.3294 28.356C44.5811 28.2689 44.8542 28.2689 45.1059 28.356L55.694 32.0523C56.1645 32.2171 56.4821 32.6642 56.4821 33.163V41.4829C56.4821 51.3839 45.6495 56.2261 45.1881 56.4263C45.0399 56.492 44.8776 56.5249 44.7176 56.5249ZM35.3059 33.9983V41.4829C35.3059 48.7886 42.7482 53.0451 44.7153 54.0427C46.6822 53.0428 54.1293 48.7675 54.1293 41.4829V33.9983L44.7176 30.7136L35.3059 33.9983Z",
    fill: "#DF1995"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 37,
    width: 14,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6865 37.2241H51.704V46.585H38.6865V37.2241Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_18_1487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 58,
    height: 58
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.223633 0.760232V55.8205C-0.223633 56.275 0.144883 56.6432 0.5991 56.6432H55.6593C56.1138 56.6432 56.4821 56.275 56.4821 55.8205V0.760232C56.4821 0.306016 56.1138 -0.0625 55.6593 -0.0625H0.5991C0.144883 -0.0625 -0.223633 0.306016 -0.223633 0.760232Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_18_1487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7546 46.5699C43.7335 46.5699 43.7101 46.5699 43.6912 46.5676C43.3475 46.5487 43.0347 46.3839 42.8253 46.1133L38.9736 41.137C38.576 40.6216 38.67 39.8829 39.1853 39.4852C39.6958 39.0876 40.4371 39.1793 40.8348 39.6946L43.8535 43.598L49.6463 37.6078C50.0957 37.1419 50.8415 37.1301 51.3098 37.5795C51.7757 38.0311 51.79 38.7747 51.338 39.243L44.6016 46.2099C44.376 46.4404 44.0723 46.5699 43.7546 46.5699Z",
    fill: "#DF1995"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 11,
    width: 26,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3057 11.1891H47.0973V25.9617H22.3057V11.1891Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_18_1487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 58,
    height: 58
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.223633 0.76011V55.8203C-0.223633 56.2748 0.144883 56.6431 0.5991 56.6431H55.6593C56.1138 56.6431 56.4821 56.2748 56.4821 55.8203V0.76011C56.4821 0.305894 56.1138 -0.0626221 55.6593 -0.0626221H0.5991C0.144883 -0.0626221 -0.223633 0.305894 -0.223633 0.76011Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_18_1487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8932 25.9372C45.2438 25.9372 44.7168 25.4102 44.7168 24.7609V14.3116L24.0793 24.636C23.5054 24.9254 22.7924 24.6926 22.5007 24.1089C22.2136 23.5302 22.4464 22.822 23.0278 22.5326L45.3661 11.3563C45.7286 11.1726 46.1637 11.1938 46.5096 11.408C46.8579 11.622 47.0696 12.0008 47.0696 12.4079V24.7609C47.0696 25.4102 46.5425 25.9372 45.8932 25.9372Z",
    fill: "#DF1995"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 25,
    height: 37
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.1892H24.7185V47.17H0V11.1892Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_18_1487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 58,
    height: 58
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.223633 0.76011V55.8203C-0.223633 56.2748 0.144883 56.6431 0.5991 56.6431H55.6593C56.1138 56.6431 56.4821 56.2748 56.4821 55.8203V0.76011C56.4821 0.305894 56.1138 -0.0626221 55.6593 -0.0626221H0.5991C0.144883 -0.0626221 -0.223633 0.305894 -0.223633 0.76011Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_18_1487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5267 47.1135C23.3385 47.1135 23.1502 47.0686 22.9785 46.9769L0.639909 35.2124C0.253968 35.0102 0.0117188 34.6099 0.0117188 34.1723V12.4079C0.0117188 12.0008 0.223401 11.622 0.569348 11.408C0.912725 11.1938 1.35037 11.1726 1.71289 11.3563L24.0512 22.5326C24.4489 22.7326 24.7008 23.1397 24.7008 23.5842V45.9368C24.7008 46.3487 24.4843 46.7298 24.1338 46.9441C23.9478 47.0569 23.7384 47.1135 23.5267 47.1135ZM2.3645 33.4618L22.35 43.9862V24.3112L2.3645 14.3116V33.4618Z",
    fill: "#DF1995"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 14
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H47.0969V13.6025H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_18_1487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 58,
    height: 58
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.223633 0.76011V55.8203C-0.223633 56.2748 0.144883 56.6431 0.5991 56.6431H55.6593C56.1138 56.6431 56.4821 56.2748 56.4821 55.8203V0.76011C56.4821 0.305894 56.1138 -0.0626221 55.6593 -0.0626221H0.5991C0.144883 -0.0626221 -0.223633 0.305894 -0.223633 0.76011Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_18_1487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.894 13.5844C45.7174 13.5844 45.5386 13.5444 45.3669 13.4596L23.5273 2.54668L1.7158 13.4596C1.13931 13.7467 0.42885 13.5162 0.136894 12.9348C-0.152491 12.3538 0.0806167 11.6456 0.661671 11.3562L23.0003 0.179899C23.3319 0.0150664 23.7225 0.0150664 24.0518 0.179899L46.4187 11.3562C46.9998 11.6479 47.2352 12.3538 46.9458 12.9348C46.7387 13.3468 46.3245 13.5844 45.894 13.5844Z",
    fill: "#DF1995"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 26,
    height: 23
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6777 5.33862H35.3963V27.7169H10.6777V5.33862Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_18_1487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 58,
    height: 58
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.223633 0.760232V55.8205C-0.223633 56.275 0.144883 56.6432 0.5991 56.6432H55.6593C56.1138 56.6432 56.4821 56.275 56.4821 55.8205V0.760232C56.4821 0.306016 56.1138 -0.0625 55.6593 -0.0625H0.5991C0.144883 -0.0625 -0.223633 0.306016 -0.223633 0.760232Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_18_1487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8766 27.6762C11.2273 27.6762 10.7002 27.1491 10.7002 26.4995V17.7514C10.7002 17.3069 10.9519 16.8998 11.3495 16.6998L33.6881 5.52354C34.2646 5.23644 34.9751 5.46926 35.2668 6.0506C35.5564 6.63166 35.321 7.33755 34.74 7.62922L13.053 18.481V26.5021C13.053 27.1514 12.5259 27.6762 11.8766 27.6762Z",
    fill: "#DF1995"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 42,
    width: 8,
    height: 6
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3057 42.197H29.4726V47.17H22.3057V42.197Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_18_1487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_18_1487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 58,
    height: 58
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.223633 0.76011V55.8203C-0.223633 56.2748 0.144883 56.6431 0.5991 56.6431H55.6593C56.1138 56.6431 56.4821 56.2748 56.4821 55.8203V0.76011C56.4821 0.305894 56.1138 -0.0626221 55.6593 -0.0626221H0.5991C0.144883 -0.0626221 -0.223633 0.305894 -0.223633 0.76011Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_18_1487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5266 47.1133C23.1052 47.1133 22.6981 46.8873 22.4887 46.4874C22.183 45.9132 22.4019 45.2001 22.9758 44.8968L27.6959 42.3931C28.2724 42.0898 28.9829 42.3063 29.2863 42.8828C29.5922 43.4567 29.3734 44.1697 28.7995 44.4731L24.0793 46.9767C23.9005 47.0684 23.7122 47.1133 23.5266 47.1133Z",
    fill: "#DF1995"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingF2);
export default __webpack_public_path__ + "static/media/living-f2.390803fabc209366ac52a40261f3f1ea.svg";
export { ForwardRef as ReactComponent };